import {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import InputForm from '../InputFormV2'
import {State} from '../../../../reducers'
import {
  cargarDistritosDelCliente,
  getMapaDistritoMunicipio,
} from '../../../../actions/catalogos.actions'
import {
  avisoDistritoPendiente,
  esNormativaV2,
  municipioQueCorrigeElDistrito,
} from '../../../../utils/normativa.utils'
import {Tooltip} from '../../../../components/Tooltip/Tooltip'

interface PropiedadesSelectDistritoReceptor {
  departamento: any
  municipio: any
  distrito: any
  error?: any
  onChange: (valor: string) => void
  onMunicipioDerivado?: (valor: string) => void
  deshabilitado?: boolean
}

export default function SelectDistritoReceptor({
  departamento,
  municipio,
  distrito,
  error,
  onChange,
  onMunicipioDerivado,
  deshabilitado,
}: PropiedadesSelectDistritoReceptor) {
  const dispatch = useDispatch()
  const {distritos, municipios, mapaDistritoMunicipio, datosEmisor} = useSelector(
    (state: State) => state.catalogos
  )
  const normativaV2 = esNormativaV2(datosEmisor)

  const codigoDepartamento = `${departamento ?? ''}`.trim()
  const codigoMunicipio = `${municipio ?? ''}`.trim()
  const codigoDistrito = `${distrito ?? ''}`.trim()

  useEffect(() => {
    if (!codigoDepartamento) return
    dispatch(cargarDistritosDelCliente(codigoDepartamento, codigoMunicipio) as any)
  }, [codigoDepartamento, codigoMunicipio, dispatch])

  useEffect(() => {
    if (!codigoDepartamento) return
    if (!onMunicipioDerivado) return
    dispatch(getMapaDistritoMunicipio(codigoDepartamento) as any)
  }, [codigoDepartamento, onMunicipioDerivado, dispatch])

  if (!normativaV2) return null

  const opciones = (distritos ?? []).map((dis: any) => ({
    ...dis,
    codigo_nombre: `${dis?.codigo} - ${dis?.valor}`,
  }))

  const sinCatalogo = !!codigoDepartamento && opciones.length === 0
  const aviso = avisoDistritoPendiente(datosEmisor, codigoDistrito)

  const seleccionarDistrito = (valor: string) => {
    onChange(valor)
    if (!onMunicipioDerivado) return
    const municipioDerivado = municipioQueCorrigeElDistrito(
      mapaDistritoMunicipio,
      municipios,
      codigoDepartamento,
      valor,
      codigoMunicipio
    )
    if (municipioDerivado) onMunicipioDerivado(municipioDerivado)
  }

  return (
    <div className='w-layout-hflex h-inputs'>
      <div className='label-input'>
        <InputForm
          required={normativaV2}
          name='distrito'
          label='Distrito'
          type='select'
          placeholder='Distrito'
          value={codigoDistrito}
          options={opciones}
          keyNameText='codigo_nombre'
          keyNameValue='codigo'
          disabled={deshabilitado || !codigoDepartamento}
          error={error}
          componentSideLabel={
            <Tooltip content='En la normativa 2.0 la dirección lleva departamento, municipio y distrito'>
              <span style={{marginLeft: 4}}>&#9432;</span>
            </Tooltip>
          }
          helperText={
            sinCatalogo
              ? 'Todavía no hay distritos disponibles para ese departamento. Revise el departamento seleccionado o inténtelo de nuevo en unos minutos.'
              : aviso && !error
              ? aviso
              : undefined
          }
          onChange={(opcion: any) => seleccionarDistrito(`${opcion?.value ?? ''}`)}
        />
      </div>
      <div className='label-input'></div>
    </div>
  )
}
